import { API_URLS } from "@/api/urls";
import axiosInstance from "@/inteceptors";
import { withApiErrorHandling } from "@/utils/apiServiceHelpers";

export const loginUser = async (
  userData: IPropsLoginForm
): Promise<IResponse> => {
  return withApiErrorHandling(
    () => axiosInstance.post<IResponse>(API_URLS.AUTH.USER_LOGIN, userData),
    {
      context: "login",
      showNotification: false, // Login component handles notifications
    }
  );
};

export const logoutUser = async (
  data: IPropsLogout
): Promise<ISuccessResponse> => {
  return withApiErrorHandling(
    () => axiosInstance.post<ISuccessResponse>(API_URLS.AUTH.USER_LOGOUT, data),
    {
      context: "general",
      showNotification: false, // Usually handled by component
    }
  );
};

export const validateInvite = async (
  inviteToken: string
): Promise<ValidateInviteResponse> => {
  const response = await axiosInstance.get<ValidateInviteResponse>(
    `${API_URLS.AUTH.VALIDATE_INVITE}${inviteToken}/validate/`
  );
  return response.data;
};

export const acceptInvite = async (
  data: AcceptInvitePayload
): Promise<InviteResponse> => {
  const { token, ...payload } = data;
  const response = await axiosInstance.patch<InviteResponse>(
    `${API_URLS.AUTH.ACCEPT_INVITE}${token}/`,
    {
      status: "accepted",
      ...payload,
    }
  );
  return response.data;
};

export const resetPassword = async (data: {
  password: string;
  confirm_password: string;
  token: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
}): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.AUTH.RESET_PASSWORD,
    data
  );
  return response.data;
};

export const googleLogin = async (token: string) => {
  const response = await axiosInstance.post<{
    access: string;
    refresh: string;
    user: UserProfile;
  }>(API_URLS.AUTH.GOOGLE_LOGIN, {
    access_token: token,
  });
  return response.data;
};

export const linkedinLogin = async (code: string) => {
  const response = await axiosInstance.post<{
    access: string;
    refresh: string;
    user: UserProfile;
  }>(API_URLS.AUTH.LINKEDIN_LOGIN, {
    code: code,
  });
  return response.data;
};

export const forgetPassword = async (email: string) => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.AUTH.FORGET_PASSWORD,
    { email: email }
  );
  return response.data;
};
